import React, { useEffect, useState } from "react"
import { Modal as MuiModal } from "@mui/material"
import { Box, Button, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined"
import AddOutlinedIcon from "@mui/icons-material/AddOutlined"
import { FILTER_VALUES } from "src/modules/const"
import { FilterRecord } from "./FilterRecord"
import { Filter } from "./Filter"
import { Tag } from "src/openapi"

type Prop = {
  open: boolean
  handleOpen: any
  handleApply: any
  tags: Tag[]
}

export const EmployeeFilterModal = ({ open, handleOpen, handleApply, tags }: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "employee" })

  const isPC = useMediaQuery({ query: "(min-width: 650px)" })

  const [filters, setFilters] = useState<Filter[]>([
    { object: "none", condition: "none", range: "", values: [] },
  ])

  const [possibleAdd, setPossibleAdd] = useState<boolean>(false)

  const _handleApply = () => {
    handleApply(filters)
  }

  const _handleOpen = (v: boolean) => {
    handleOpen(v)
  }

  const _handleDelete = (index: number) => {
    setFilters(filters.filter((value, i) => i !== index))
  }

  const addNewFilter = () => {
    let arr: any[] = []
    filters.map((f) => {
      arr.push({ object: f.object, condition: f.condition, range: f.range })
    })
    arr.push({ object: "none", condition: "none", range: "none" })
    setFilters(arr)
  }

  const setObject = (index: number, obj: string) => {
    const updatedFilters = filters.map((user: Filter, i) => {
      if (i == index) {
        user.object = obj
      }
      return user
    })
    setFilters(updatedFilters)
  }

  const setCondition = (index: number, cond: string) => {
    const updatedFilters = filters.map((user: Filter, i) => {
      if (i == index) {
        user.condition = cond
      }
      return user
    })
    setFilters(updatedFilters)
  }

  const setRange = (index: number, rang: string) => {
    const updatedFilters = filters.map((user: Filter, i) => {
      if (i == index) {
        user.range = rang
      }
      return user
    })
    setFilters(updatedFilters)
  }

  const setValues = (index: number, val: number[]) => {
    const updatedFilters = filters.slice()
    updatedFilters[index].values = val
    setFilters(updatedFilters)
  }

  const validation = () => {
    let len = filters.length

    if (len > 0) {
      let f = filters[len - 1]
      if (
        f.object == "none" ||
        ((f.object == FILTER_VALUES.TAG || f.object == FILTER_VALUES.TYPE) && f.range == "") ||
        (f.object == FILTER_VALUES.STATUS && f.range == "none")
      ) {
        setPossibleAdd(false)
      } else {
        setPossibleAdd(true)
      }
    } else {
      setPossibleAdd(true)
    }
  }

  useEffect(() => {
    validation()
  }, [filters])

  return (
    <MuiModal open={open} disableAutoFocus={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isPC ? 1000 : "98vw",
          maxHeight: "95vh",
          height: "440px",
          overflowY: "auto",
          bgcolor: "#FFF",
          boxShadow: 24,
          borderRadius: isPC ? "2px" : "1px",
          p: isPC ? "40px" : "10px",
        }}
      >
        <Box
          width="sm"
          display="flex"
          flexDirection="column"
          sx={{ borderRadius: "10px", bgcolor: "white", borderColor: "white", p: "0px" }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <DisabledByDefaultOutlinedIcon
              sx={{ color: "#00C298", cursor: "pointer", fontSize: "26px" }}
              onClick={() => handleOpen(false)}
            />
          </Box>
          <Typography.CardHead
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              paddingBottom: "10px",
              borderBottom: "1px solid #F3F3F3",
            }}
          >
            {t("filter_setting")}
          </Typography.CardHead>
          <Box
            sx={{
              py: "10px",
              display: "block",
              alignItems: "center",
              height: "300px",
              overflowY: "scroll",
            }}
          >
            {filters.map((filter, index) => {
              return (
                <FilterRecord
                  key={`filter_${index}`}
                  filter={filter}
                  setObject={setObject}
                  setCondition={setCondition}
                  setRange={setRange}
                  setValues={setValues}
                  handleDelete={_handleDelete}
                  tags={tags}
                  index={index}
                />
              )
            })}
            <Button
              variant="outlined"
              sx={{
                width: "160px",
                height: "40px",
                border: "1px solid #B9B9B9",
                color: "#333333",
                fontSize: "15px",
                fontWeight: "700",
                fontFamily: "Zen Kaku Gothic New !important",
              }}
              disabled={!possibleAdd}
              onClick={addNewFilter}
            >
              {t("filter_add")}
              <AddOutlinedIcon />
            </Button>
          </Box>

          <Box display="block" textAlign="right">
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                borderColor: "#00C298",
                color: "#00C298",
              }}
              onClick={() => {
                handleOpen(false)
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                backgroundColor: "#00C298",
                color: "white",
                "&:hover": {
                  color: "#00C298",
                },
              }}
              onClick={() => {
                _handleApply()
                _handleOpen(false)
              }}
            >
              {t("button_apply")}
            </Button>
          </Box>
        </Box>
      </Box>
    </MuiModal>
  )
}
